import { css } from "lit";

export default css`
    :host {
        display: block;
        font-family: var(--fields-pane-font-family);
        font-size: var(--fields-pane-font-size);
    }

    p {
        margin: 8px 0 4px;
    }

    .zone {
        display: grid;
        width: var(--fields-pane-bucket-width);
        min-height: var(--fields-pane-bucket-min-height);
        background: var(--fields-pane-bucket-background);
        border: var(--fields-pane-bucket-border);
        border-radius: var(--fields-pane-radius);
    }

    :host([list]) .zone {
        min-height: 0;
        padding: 2px 0;
        background: transparent;
        border: var(--fields-pane-field-border);
    }

    /* the drop feedback fades in when a drag starts and out when it ends */
    :host {
        transition: opacity var(--fields-pane-transition);
    }

    .zone {
        transition:
            background-color var(--fields-pane-transition),
            border-color var(--fields-pane-transition);
    }

    :host([faded]) {
        opacity: var(--fields-pane-faded-opacity);
    }

    :host([drop-target]) .zone {
        border: var(--fields-pane-drop-target-border);
        background: var(--fields-pane-drop-target-background);
    }

    :host([drop-active]) .zone {
        border: var(--fields-pane-drop-active-border);
        background: var(--fields-pane-drop-active-background);
    }
`;
